import type { TripAlert } from '@/utils/tripAlerts';
import {
  type Notification,
  type NotificationSeverity,
  notificationSeverityOrder,
} from './types';

const priorityToSeverity: Record<TripAlert['priority'], NotificationSeverity> = {
  high: 'critical',
  medium: 'warning',
  low: 'info',
};

export const tripAlertToNotification = (
  alert: TripAlert,
  createdAt: number = Date.now(),
): Notification => {
  return {
    id: alert.id,
    title: alert.title,
    body: alert.message,
    scope: 'trip',
    scopeId: alert.tripId,
    kind: alert.type,
    severity: priorityToSeverity[alert.priority] ?? 'info',
    createdAt,
    source: 'trip-alerts',
    meta: {
      tripName: alert.tripName,
      tripId: alert.tripId,
      budgetMetadata: alert.budgetMetadata,
      originalType: alert.type,
    },
    cta: alert.actionLabel
      ? {
        label: alert.actionLabel,
        action: {
          type: 'callback',
          id: `trip-alert:${alert.type}`,
          params: {
            tripId: alert.tripId,
          },
        },
      }
      : undefined,
  };
};

export const tripAlertsToNotifications = (
  alerts: TripAlert[],
  createdAt: number = Date.now(),
): Notification[] => alerts.map((alert) => tripAlertToNotification(alert, createdAt));

export const sortNotifications = (notifications: Notification[]): Notification[] => {
  return [...notifications].sort((a, b) => {
    const aSeverity = notificationSeverityOrder.indexOf(a.severity);
    const bSeverity = notificationSeverityOrder.indexOf(b.severity);
    if (aSeverity !== bSeverity) {
      return aSeverity - bSeverity;
    }
    return (b.createdAt ?? 0) - (a.createdAt ?? 0);
  });
};
